// extracted by mini-css-extract-plugin
export default {"loaderSmall":"LoaderSmall_loaderSmall__A+ohd","spin":"LoaderSmall_spin__L8Gb-"};